<script>
import VueDropzone from 'vue2-dropzone'

export default {
  components: { VueDropzone },

  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
    additionalParams: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      vdzOptions: {
        acceptedFiles: '.jpg,.jpeg,.png',
        url: '/api',
        // thumbnailWidth: 125,
        // thumbnailHeight: 125,
        maxFilesize: 5,
      },
    }
  },

  computed: {
    currentUser() {
      return this.$store.state.auth.currentUser
    },
  },

  created() {
    Object.assign(this.vdzOptions, this.options)
  },

  methods: {
    sendingEvent(file, xhr, formData) {
      const { accessToken } = this.currentUser
      xhr.setRequestHeader('Authorization', accessToken)
      Object.keys(this.additionalParams).forEach((key) => {
        const value = this.additionalParams[key]
        formData.append(key, value)
      })
    },
    successEvent(file, response) {
      const newToken = file.xhr.getResponseHeader('set-authorization')
      if (newToken) {
        const user = Object.assign({}, this.currentUser, {
          accessToken: newToken,
        })
        this.$store.commit('auth/SET_CURRENT_USER', user)
      }
      this.$emit('upload-success', response)
    },
    errorEvent(file, message, xhr) {
      if (xhr && xhr.status === 401) {
        this.$router.push({ name: 'login', meta: { interceptor: true } })
      }
    },
    clearFiles() {
      this.$refs.vueDz.removeAllFiles(true)
    },
  },
}
</script>

<template>
  <VueDropzone
    id="dropzone"
    ref="vueDz"
    :options="vdzOptions"
    @vdropzone-sending="sendingEvent"
    @vdropzone-success="successEvent"
    @vdropzone-error="errorEvent"
  />
</template>

<style lang="scss">
@import '~vue2-dropzone/dist/vue2Dropzone.min.css';

#dropzone {
  border-style: dashed;
}
</style>
